import React, { Component } from 'react'
import DateTime from 'react-datetime'
import _ from 'lodash';
import renderIf from '../../../pkgs/render_if';

import {HelpBlock} from 'react-bootstrap';

export default class TimeField extends React.Component {

  constructor(props){
    super(props);
        this.state = {
            value: '00:00',
            errors: false,
            touched_and_blank: false,
            value: this.props.field_value,
            class_names: '',
        }
    }

  componentDidMount = () => {
    //console.log('Here is componentDidMount');
    //console.log(this.props.editingInstance[this.props.field_id]);
    if (this.props.editingInstance[this.props.field_id]) {
        let time_object = this.props.editingInstance[this.props.field_id];
        let value = moment(time_object,'H:mm:ss').format('h:mm a');
        this.setState({value});
    }
  }

  componentWillReceiveProps = (nextProps) => {
    //console.log('Here is componentWillRecieveProps');
    //console.log(nextProps.editingInstance[this.props.field_id]);
    if (nextProps.editingInstance[this.props.field_id]) {
        let time_object = nextProps.editingInstance[this.props.field_id]
        let value = moment(time_object,'H:mm:ss').format('h:mm a')
        this.setState({value});
    }
  }

  onChange = (time_object) => {
    let time_value_as_string = moment(time_object,'h:mm a').format('h:mm a');
    let military_time = moment(time_object,'H:mm').format('H:mm') + ':00';
    //console.log(military_time);

    let value = military_time;
    let key = String(this.props.field_id).toLowerCase().split(' ').join('_');
    this.setState({value:time_value_as_string})
    if (String(value).length > 0 && String(value) !== 'null') {
      this.setState({
        errors: false,
        touched_and_blank: false,
        class_names: '',
      });
      //this.props.onHandleSuccess(key);
    }
    if (!value && this.props.field_required === true) {
      this.setState({
        errors: true,
        touched_and_blank: false,
        class_names: 'error',
      });
      //this.props.onHandleErrors(key);
    }
  }

  handleBlur = () => {
    if (this.props.field_required === true && !this.state.value) {
      this.setState({touched_and_blank: true, class_names: 'error'});
    }

    let value = moment(this.state.value,'H:mm').format('H:mm') + ':00';
    let key = String(this.props.field_id).toLowerCase().split(' ').join('_');
    //console.log(value);
    this.props.onSelectChange(key, value);
  }

  render() {
    let placeholder = this.props.field_placeholder;
    return (
    <div>
      <div>
      <DateTime
        dateFormat={false}
        timeformat={true}
        value={this.state.value}
        onChange={this.onChange}
        onBlur={this.handleBlur}
        timeConstraints={{ minutes: {min:0, max:60, step:15}}}
        id={`${this.props.data_key}`}
        {...this.state}
      />
      </div>
      <div>
        {renderIf(this.state.errors === true)(
          <HelpBlock style={{color: 'red'}}>{this.props.field_label} cannot be blank</HelpBlock>
        )}
        {renderIf(this.state.touched_and_blank === true)(
          <HelpBlock style={{color: 'red'}}>{this.props.field_label} is a required field.</HelpBlock>
        )}
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/antd_time_picker.js